export const getMissionStatus = async (token) => {
    try {
        const response = await fetch(`https://blue-moon-app-backend.vercel.app/missionStatus`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });
        if (response.ok) {
            const data = await response.json();
            const missionStatus = data.missionStatus;
            return missionStatus;
        } else {
            throw new Error('Failed to fetch mission status');
        }
    } catch (error) {
        console.error('Error in getMissionStatus:', error);
    }
}